export interface IInfinitePageParams {
  page?: number;
  itemCount?: number;
}

export interface INodes<T> {
  nodes: T[];
}

export interface ICopyrights {
  name: string | null;
  year: number | null | string;
}

export interface IExternalId {
  id: string;
  type: string;
  link?: string | null;
  isFullName?: boolean;
}

export interface ISalesChannelAvailable {
  totalPageCount: number;
  salesChannelResponse: {
    ddexStandard: number;
    distributionForm: number;
    id: string;
    isActive: boolean;
    name: string;
    messageRecipient: {
      id: string;
      name: string;
    };
  }[];
}

export interface ILightListItem {
  id: string;
  name: string;
}

export interface IPhoneNumber {
  prefix: string;
  number: string;
}

export interface ITitle {
  title: string;
  language: number;
  version?: string;
}

export interface ITotalPageCount {
  totalPageCount: number;
}
export interface IInfinitePageResponse<Item = {}> extends ITotalPageCount {
  items: Item[];
}
export interface IInfinitePageStatisticsResponse<Item = {}, Stats = {}>
  extends IInfinitePageResponse<Item> {
  statistics: Stats;
}

export interface IStatistics<T extends {}> {
  statistics: T;
}

export interface IVersion {
  version: number;
}

export interface IAddress {
  street: string;
  houseNumber: string;
  flatNumber?: string;
  zipCode: string;
  city: string;
  countryAlfa2: string;
}

export interface IWaitingForFile {
  waitingForFile?: boolean;
}

export interface IArtistWithRoleForm {
  id: string;
  role: ARTIST_ROLE;
  nickname: string;
}

export interface IArtistWithRoleMutation {
  artistId: string;
  artistRole: ARTIST_ROLE;
  rolePlacement: number;
}

export enum PRIORYTY {
  Low = 1,
  Medium = 2,
  High = 3,
}

export interface ILanguage {
  name: string;
  id: number;
}

export enum STATUS {
  unknown = -1,
  draft = 1,
  notVerified = 2,
  inVerification = 3,
  verified = 4,
}

export enum ACTIVE_STATUS {
  Inactive = 0,
  Active = 1,
}

export enum ARTIST_ROLE {
  unknown = -1,
  mainArtist = 1,
  featuredArtist = 2,
  conductor = 3,
  orchestra = 4,
  composer = 5,
  lyricist = 6,
  producer = 7,
  actor = 8,
  arranger = 9,
  choir = 10,
  soloist = 11,
  cymbals = 12,
  flute = 13,
  frenchHorn = 14,
  drums = 15,
  davul = 16,
  guitar = 17,
  mandolin = 18,
  tenorSaxophone = 19,
  accordion = 20,
  mixingEngineer = 21,
  contrabass = 22,
  piano = 23,
  percussion = 24,
  remixer = 25,
}

export enum GENRE {
  unknown = -1,
  rock = 1,
  pop = 2,
  rapHipHop = 3,
  discoPolo = 4,
  jazz = 5,
  industrial = 6,
  dance = 7,
  electronic = 8,
  house = 9,
  reggae = 10,
  bossaNova = 11,
  blues = 12,
  metal = 13,
  disco = 14,
  folk = 15,
  chillout = 16,
  latin = 17,
  devotional = 18,
  adultContemporary = 19,
  alternative = 20,
  anime = 21,
  antiquesAndCollectibles = 22,
  audiobooks = 23,
  childrensMusic = 24,
  christian = 25,
  classical = 26,
  comedy = 27,
  country = 28,
  easyListening = 29,
  educational = 30,
  fitnessAndWorkout = 31,
  healthAndFitness = 32,
  holidayMusic = 33,
  indian = 34,
  inspirational = 35,
  instructional = 36,
  karaoke = 37,
  motown = 38,
  oldies = 39,
  rbSoul = 40,
  samba = 41,
  soundtracks = 42,
  spokenWord = 43,
  wallpaper = 44,
  world = 45,
  dancehall = 46,
}

export enum DOCUMENT_NUMERATION_TYPE {
  unknown = -1,
  Month = 1,
  Year = 2,
}

export enum MONTH {
  unknown = -1,
  January = 1,
  February = 2,
  March = 3,
  April = 4,
  May = 5,
  June = 6,
  July = 7,
  August = 8,
  September = 9,
  October = 10,
  November = 11,
  December = 12,
}

export enum EMAIL_SEND {
  notSend = 0,
  planned = 1,
  send = 2,
  deleted = 3,
  emailNotExist = 4,
  error = 5,
}
